// extracted by mini-css-extract-plugin
export default {"root":"PlayerUi_root__hYI1x","header":"PlayerUi_header__BxopC","trigger":"PlayerUi_trigger__udeCW"};